import App from './App.svelte';
import Pagos from './pagos/pagos.svelte';
import AppCliente from './Appcliente.svelte';
import AppLinkCliente from './AppLinkCliente.svelte';
import AppLinkClienteCear from './AppLinkClienteCear.svelte';
import AppLinkVenta from './AppLinkVenta.svelte';
import AppTest from './Apptest.svelte';

const urlParams = new URLSearchParams(window.location.search);
const modulo = urlParams.get('m') || '';
const submodulo = urlParams.get('sm') || '';
const token = urlParams.get('t') || '';

const cliente = urlParams.get('c') || 0;
const codigo = urlParams.get('h') || 'x';
const pagoid = urlParams.get('pid') || '';


if (modulo === '') {
	const app = new App({
		target: document.getElementById("app"),
	});
}

if (modulo === 'pagos') {
	const app = new Pagos({
		target: document.getElementById("app"),
	});
}

if (modulo === 'cliente'){
	const app = new AppCliente({
		target: document.getElementById("app"),
		props: {
			cliente : cliente,
			codigo : codigo,
			submodulo : submodulo
		}
	});
}


if (modulo === 'link-pago'){ 
	const app = new AppLinkCliente({
		target: document.getElementById("app"),
		props: {
			cliente : cliente,
			codigo : codigo,
			pagoid : pagoid 
		}
	});
}

if (modulo === 'link-venta'){ 
	const app = new AppLinkVenta({
		target: document.getElementById("app"),
		props: {
			cliente : cliente,
			codigo : codigo,
			pagoid : pagoid 
		}
	});
}

if (modulo === 'test'){ 
	const app = new AppTest({
		target: document.getElementById("app"),
		props: {
			
		}
	});
}


export default app;